import { Flex, Text } from '@farmersdog/corgi-x';
import { Check } from '@farmersdog/corgi-x/icons';

interface CheckmarkListProps {
  listItems: string[];
}

export function CheckmarkList(props: CheckmarkListProps) {
  return (
    <>
      <Flex direction="column" gap="sm" alignItems="start">
        {props.listItems.map((item, index) => (
          <Flex
            key={`list-item-${index}`}
            direction="row"
            gap="xs"
            alignItems="baseline"
          >
            <Check size="14px" baseColor="Kale2" />
            <Text variant="heading-16">{item}</Text>
          </Flex>
        ))}
      </Flex>
    </>
  );
}
